
const PENDING_KEY = 'player_linked_pending';

function read(key: string): number[] {
  try {
    return JSON.parse(localStorage.getItem(key) || '[]') as number[];
  } catch {
    return [];
  }
}

function write(key: string, ids: number[]): void {
  try {
    localStorage.setItem(key, JSON.stringify(Array.from(new Set(ids))));
  } catch {
    // Storage unavailable (Safari private mode / quota) — swallow silently.
  }
}

export function getPendingPlayerLinks(): number[] {
  return read(PENDING_KEY);
}

export function markPlayerLinkPending(casinoId: number): void {
  write(PENDING_KEY, read(PENDING_KEY).concat(casinoId));
}
